export default __webpack_public_path__ + "f5ff9598d39f677183c6c38c7ddd495e.png";